import { spanFerkel } from '../../js/utils/math.js';
import { doc, cursor, scrl, getPosition, inViewport, registeredLoops, touchDevice, siteurl, lenisScrollTo, jumpTo, addGlobalEventListener} from '../../js/utils/events.js';
import { gsap } from "gsap";

export default class WorkFilter {
  init(root) {
    this.root = root;
    this.workGridEl = this.root.querySelector('.work-grid');
    this.filterButtons = this.root.querySelectorAll('.work-filter button');
    this.workItems = this.root.querySelectorAll('.work-grid-item');
    this.activeFilter = null;

    this.setupFilterButtons();
  }

  setupFilterButtons() {
    this.filterButtons.forEach(button => {
      button.addEventListener('click', () => {
        const filter = button.getAttribute('data-filter');

        // Toggle filter
        if (this.activeFilter === filter) {
          this.activeFilter = null;
        } else {
          this.activeFilter = filter;
        }

        this.updateUI();
      });
    });
  }

  updateUI() {
    // Toggle active button
    this.filterButtons.forEach(button => {
      const isActive = button.getAttribute('data-filter') === this.activeFilter;
      button.classList.toggle('active', isActive);
    });

    // Filter grid items
    this.workItems.forEach(item => {
      const tags = item.getAttribute('data-tags')?.split(',').map(tag => tag.trim()) || [];

      const show = !this.activeFilter || tags.includes(this.activeFilter);
      item.style.display = show ? '' : 'none';
    });
  }
}
